// import {
//   Input,
//   OnInit,
//   Directive,
//   ViewContainerRef,
//   TemplateRef,
//   OnDestroy,
// } from '@angular/core';
// import { Subject, Subscription } from 'rxjs';
// import { distinctUntilChanged, takeUntil } from 'rxjs/operators';
// import { AuthService } from '../Auth/auth.service';
// import { UserProfileData } from '../../interfaces/user-profile-data';

// @Directive({
//   selector: '[ifRoles]',
// })
// export class UserAccessDirective implements OnInit, OnDestroy {
//   private subscription: Subscription[] = [];
//   // the role the user must have
//   @Input() public ifRoles!: Array<string>;
//   roleValue: number = -1;

//   /**
//    * @param {ViewContainerRef} viewContainerRef -- the location where we need to render the templateRef
//    * @param {TemplateRef<any>} templateRef -- the templateRef to be potentially rendered
//    * @param {RolesService} rolesService -- will give us access to the roles a user has
//    */
//   constructor(
//     private viewContainerRef: ViewContainerRef,
//     private templateRef: TemplateRef<any>,
//     private authService: AuthService
//   ) {}

//   roles: string[] = [];
//   public ngOnInit(): void {
//     this.subscription.push(
//       this.authService.roles().subscribe((res) => {
//         if (!res.roles) {
//           // Remove element from DOM
//           this.viewContainerRef.clear();
//         }
//         // user Role are checked by a Roles mention in DOM
//         this.roles = res.roles;
//         let role: string[] = [];

//         this.authService
//           .getUserProfile$()
//           .subscribe((results: UserProfileData) => {
//             try {
//               // get user type from the JWT
//               let roleType = results['http://allegion.com/claims/user_type'];
//               let applicationRoles: string[] = [];

//               // get user roles from the JWT
//               role = results['http://allegion.com/claims/roles'];

//               // check roles and user types to assign custom application roles to control access
//               switch (roleType) {
//                 case 'internal':
//                   if (role.includes('TechSupport')) {
//                     applicationRoles.push('TechSupport');
//                   } else if (role.includes('Admin')) {
//                     applicationRoles.push('Admin');
//                   } else {
//                     applicationRoles.push('Onboarding');
//                   }
//                   break;

//                 case 'external':
//                   role.forEach((role) => {
//                     switch (role) {
//                       case 'FullControl':
//                         applicationRoles.push('FullControl');
//                         break;
//                       case 'ViewOnly':
//                         applicationRoles.push('ViewOnly');
//                         break;
//                       case 'APIUser':
//                         applicationRoles.push('APIUser');
//                         break;
//                       case 'EBUserCP':
//                         applicationRoles.push('EBUserCP');
//                         break;
//                       case 'EBUserCPCM':
//                         applicationRoles.push('EBUserCPCM');
//                         break;
//                     }
//                   });
//                   break;
//               }

//               // custom roles are checked to give access to this particular control
//               applicationRoles.forEach((role) => {
//                 if (this.roleValue < 0) {
//                   this.roleValue = this.roles.findIndex((r) =>
//                     this.ifRoles.includes(r)
//                   );
//                 }
//               });

//               // if the user does not have access this will remove or add controls to the DOM
//               if (this.roleValue < 0) {
//                 this.viewContainerRef.clear();
//               } else {
//                 // appends the ref element to DOM
//                 this.viewContainerRef.clear();
//                 this.viewContainerRef.createEmbeddedView(this.templateRef);
//               }
//             } catch (error) {}
//           });
//       })
//     );
//   }

//   /**
//    * on destroy cancels the API if its fetching.
//    */
//   public ngOnDestroy(): void {
//     this.subscription.forEach((subscription: Subscription) =>
//       subscription.unsubscribe()
//     );
//   }
// }
// @Directive({
//   selector: '[ifPermissions]',
// })
// export class IfPermissionsDirective implements OnInit, OnDestroy {
//   private subscription: Subscription[] = [];
//   @Input() public ifPermissions!: Array<string>;

//   constructor(
//     private viewContainerRef: ViewContainerRef,
//     private templateRef: TemplateRef<any>,
//     private authService: AuthService
//   ) {}

//   ngOnInit(): void {
//     this.subscription.push(
//       this.authService
//         .getPermissions()
//         .pipe(
//           distinctUntilChanged(
//             (prev, curr) => JSON.stringify(prev) === JSON.stringify(curr)
//           )
//         )
//         .subscribe((permissions: string[]) => {
//           console.log('User Permissions:', permissions);
//           console.log('Required Permissions:', this.ifPermissions);

//           let hasPermission = false;

//           // Check if we are looking for an empty permissions scenario
//           if (this.ifPermissions.includes('') && permissions.length === 0) {
//             hasPermission = true;
//           } else {
//             // Check each required permission
//             this.ifPermissions.forEach((requiredPermission) => {
//               if (requiredPermission.startsWith('!')) {
//                 // Negated permission check
//                 const actualPermission = requiredPermission.substring(1);
//                 if (!permissions.includes(actualPermission)) {
//                   hasPermission = true;
//                 }
//               } else if (permissions.includes(requiredPermission)) {
//                 // Regular permission check
//                 hasPermission = true;
//               }
//             });
//           }

//           console.log('Has Permission:', hasPermission);

//           // Render or clear the view based on the permission check
//           if (hasPermission) {
//             if (this.viewContainerRef.length === 0) {
//               this.viewContainerRef.createEmbeddedView(this.templateRef);
//             }
//           } else {
//             this.viewContainerRef.clear();
//           }
//         })
//     );
//   }

//   ngOnDestroy(): void {
//     this.subscription.forEach((subscription) => subscription.unsubscribe());
//   }
// }

import {
  Input,
  OnInit,
  Directive,
  ViewContainerRef,
  TemplateRef,
  OnDestroy,
} from '@angular/core';
import { Subject } from 'rxjs';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { AuthService } from '../Auth/auth.service';
import { UserProfileData } from '../../interfaces/user-profile-data';

@Directive({
    selector: '[ifRoles]',
    standalone: false
})
export class UserAccessDirective implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>(); // Used for cleanup
  @Input() public ifRoles!: Array<string>;
  roleValue: number = -1;
  roles: string[] = [];

  constructor(
    private viewContainerRef: ViewContainerRef,
    private templateRef: TemplateRef<any>,
    private authService: AuthService
  ) {}

  public ngOnInit(): void {
    this.authService
      .roles()
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        if (!res.roles) {
          this.viewContainerRef.clear();
          return;
        }
        this.roles = res.roles;
        let role: string[] = [];

        this.authService
          .getUserProfile$()
          .pipe(takeUntil(this.destroy$))
          .subscribe((results: UserProfileData) => {
            try {
              let roleType = results['http://allegion.com/claims/user_type'];
              let applicationRoles: string[] = [];
              role = results['http://allegion.com/claims/roles'];

              switch (roleType) {
                case 'internal':
                  if (role.includes('TechSupport')) {
                    applicationRoles.push('TechSupport');
                  } else if (role.includes('Admin')) {
                    applicationRoles.push('Admin');
                  } else {
                    applicationRoles.push('Onboarding');
                  }
                  break;

                case 'external':
                  role.forEach((role) => {
                    switch (role) {
                      case 'FullControl':
                        applicationRoles.push('FullControl');
                        break;
                      case 'ViewOnly':
                        applicationRoles.push('ViewOnly');
                        break;
                      case 'APIUser':
                        applicationRoles.push('APIUser');
                        break;
                      case 'EBUserCP':
                        applicationRoles.push('EBUserCP');
                        break;
                      case 'EBUserCPCM':
                        applicationRoles.push('EBUserCPCM');
                        break;
                    }
                  });
                  break;
              }

              applicationRoles.forEach((role) => {
                if (this.roleValue < 0) {
                  this.roleValue = this.roles.findIndex((r) =>
                    this.ifRoles.includes(r)
                  );
                }
              });

              if (this.roleValue < 0) {
                this.viewContainerRef.clear();
              } else {
                this.viewContainerRef.clear();
                this.viewContainerRef.createEmbeddedView(this.templateRef);
              }
            } catch (error) {}
          });
      });
  }

  public ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}

@Directive({
    selector: '[ifPermissions]',
    standalone: false
})
export class IfPermissionsDirective implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>(); // Used for cleanup
  @Input() public ifPermissions!: Array<string>;

  constructor(
    private viewContainerRef: ViewContainerRef,
    private templateRef: TemplateRef<any>,
    private authService: AuthService
  ) {}
  /* istanbul ignore next */
  ngOnInit(): void {
    this.authService
      .getPermissions()
      .pipe(
        distinctUntilChanged(
          (prev, curr) => JSON.stringify(prev) === JSON.stringify(curr)
        ),
        takeUntil(this.destroy$)
      )
      .subscribe((permissions: string[]) => {
        let hasPermission = false;

        if (this.ifPermissions.includes('') && permissions.length === 0) {
          hasPermission = true;
        } else {
          this.ifPermissions.forEach((requiredPermission) => {
            if (requiredPermission.startsWith('!')) {
              const actualPermission = requiredPermission.substring(1);
              if (!permissions.includes(actualPermission)) {
                hasPermission = true;
              }
            } else if (permissions.includes(requiredPermission)) {
              hasPermission = true;
            }
          });
        }

        if (hasPermission) {
          if (this.viewContainerRef.length === 0) {
            this.viewContainerRef.createEmbeddedView(this.templateRef);
          }
        } else {
          this.viewContainerRef.clear();
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
